import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "@environments/environment";
import {dataArrayForAnnoTest} from "@app/components-fuse/layout/components/toolbar/toolbar-tool-popup/data_for_test";
import {cloneDeep} from "lodash";
import md5 from "uuid/dist/cjs-browser/md5";
import * as uuid from 'uuid';
import {dataResponses} from "@app/components-fuse/layout/components/toolbar/toolbar-tool-popup/response_for_test";
import {AngularFireDatabase} from "@angular/fire/compat/database";

@Injectable({
  providedIn: 'root'
})
export class ToolbarToolService {

  constructor(
    private db: AngularFireDatabase,
    private http: HttpClient,
  ) {

  }

  doStuff() {
    // dataArrayForAnnoTest.forEach(data => {
    //   const urlParams = cloneDeep(data);
    //   delete urlParams.Raison;
    //   delete urlParams.token;
    //   this.http.post<any>(`${environment.apiUrl}${'/4dm1n/publicActions'}`, {
    //     action: 'createUserAndSubmitResponse',
    //     params: {
    //       create: {
    //         comId: 1700,
    //         gender: data.internal_gender,
    //         birthdate: data.age_range_inaf.startsWith("je_prefere_ne_pas_repondre") ?
    //           null : new Date().getFullYear() - parseInt(data.age_range_inaf.slice(0, 2), 10),
    //         urlParams,
    //         email: `info+publicUser-${uuid.v4()}@inbe.ca`,
    //         firstName: data.token,
    //         lastName: `${data.token}ovitch`,
    //         lang: 'fr',
    //         isPublic: true,
    //       },
    //       submit: {
    //         surveyId: 3375,
    //         publication: 'd09316c6-3ac5-41a3-a68b-b0c4fef5f806',
    //         data: dataResponses[data.token],
    //       }
    //
    //     }
    //   }).subscribe(data => console.log(data));
    // });
  }

  delete3375(){
    // this.db.object(`annotations/${'3375'}`).remove().then();
  }



  sendPostToBackEnd(path: string, action: string, params: Array<Array<string>>) {
    this.http.post<any>(`${environment.apiUrl}${path}`, {
      action: action,
      params: {
        ...params.reduce((obj, param) => ({...obj, [param[0]]: param[1]}), {})
      }
    }).subscribe(data => console.log(data));
  }


}
